module.exports = __webpack_public_path__ + "static/media/community-Camilo.1ac04ccd.jpg";